import { GetInfluencersListQuery } from 'generated/graphql';
import { Influencer } from './InfluencerList.types';

type RawInfluencer = NonNullable<GetInfluencersListQuery['creators'][number]>;

const toTimestamp = (value: string | null | undefined): number | null => {
  if (!value) return null;
  const parsed = new Date(value).getTime();
  return Number.isNaN(parsed) ? null : parsed;
};

const toStringOrEmpty = (value: string | null | undefined): string =>
  value || '';

const toInfluencer = (creator: RawInfluencer): Influencer => ({
  id: creator.id,
  firstName: toStringOrEmpty(creator.firstName),
  lastName: toStringOrEmpty(creator.lastName),
  customURL: toStringOrEmpty(creator.customURL),
  tier: creator.tier ?? null,
  createdAt: toTimestamp(creator.createdAt),
  publishedAt: toTimestamp(creator.publishedAt),
  instagramFollowersCount: creator.instagramFollowersCount ?? null,
  profileInstagram: creator.profileInstagram || null,
  profileTiktok: creator.profileTiktok || null,
  profileYoutubeChannel: creator.profileYoutubeChannel || null,
  businessModel: creator.businessModel ?? null,
  mode: creator.mode ?? null,
  mediaCoverPath: creator.mediaCover?.image ?? null,
  email: creator.email || null,
});

export const toInfluencers = (
  creators: GetInfluencersListQuery['creators'],
): Influencer[] =>
  creators
    .filter((creator): creator is RawInfluencer => Boolean(creator))
    .map(toInfluencer);
